import {c, color, theme, is_mobile} from './modules/settings.js';

(function($) {

  document.ontouchmove = function (e) {
    e.preventDefault();
    // alert(e);
    //cosole.log(e);
    return true;
  }

  var breakPointLg = 1200,
      breakPointMd = 768,
      breakPointSm = 480;


      // ids of non splitting tables
  var nosplit = [];

  $(document).on('DOMContentLoaded accordion-opened noteLoaded', function(){
    $('.ns-table-wrap > div table').each(function(){
      /*if(arrayContains($(this).parent().attr('tableid'), nosplit)){
        $(this).parents('.ns-table-wrap').addClass('nosplit')
      }*/
      var colCount = $(this).find('tbody tr:nth-of-type(3) td').length;
      if (colCount < 10) {
        $(this).parents('.ns-table-wrap').addClass('nosplit');
      }
      if (colCount > 19) {
        $(this).parents('.ns-table-wrap:not(.nosplit)').addClass('js-table-early-break');
      }
    });

    $(window).resize();


    /**
     * UGLY HACK DONT REPEAT
     */
    $('[tableid*="783ee5c3-de11-4d95-9a9d-f06356270881"]').closest('.ns-table-wrap').addClass('no-first-line');

  });

  $(window).on('resize', function () {
    // console.log('resize called');
    // if($(window).width() < breakPointSm) {
    //   $('.js-responsive-table').addClass('js-please-rotate');
    // } else {
    //   $('.js-responsive-table').removeClass('js-please-rotate');
    // }

    if ($(window).width() >= breakPointMd) {
      
       //console.log('big mobile size');

      
      $('.js-table-early-break:not(.nosplit)').each(function () {
        var hasClone = $(this).find('.clone').length;
        if (hasClone) {
           //console.log('has a clone already')
        } else {
          //console.log('no clone so far')
          createClone($(this).find('table'));
        }
      });
    } else if ($(window).width() < breakPointMd) {
      // console.log('mobile size');
      $('.ns-table-wrap').each(function () {
        var hasClone = $(this).find('.clone').length;
        if (hasClone) {
          // console.log('has a clone already')
        } else {
          // console.log('no clone so far')
          createClone($(this).find('table'));
        }
      });
    } else {
      // console.log('desktop size');
      $('.ns-table-wrap:not(.nosplit)').each(function(){
        var hasClone = $(this).find('.clone').length;
        if (hasClone) {
          $(this).find('.clone').remove();
          $(this).removeClass('js-responsive-table');
        }
      });
    }
  });

  function createClone(table) {
    console.log("table", table);
    
    // iterate through each table 
    table.each(function () {
      // store wrapper

      // fix first row
      $(this).find('tr td:first-of-type').each(function(){
        $(this).addClass('fixed');
        if($(this).parent().prev().find('td:first-of-type').attr('rowspan') == 2){
          $(this).removeClass('fixed');
        }
      });

      var wrapper = $(this).parents('.ns-table-wrap');

      console.log("wrapper", wrapper);

      wrapper.addClass('js-responsive-table');

      // remove all colspan and rowspans as well as styles and colgroups from the table
      // thius ensures no styling overrides the setup in css and proper scrolling happens.

      $(this).find('style').remove();
      $(this).find('colgroup').remove();

      // if there is a footnote, put it in the wrapper (footnote should not scroll with table)
      if ($(this).siblings('div').children('.ns-style-footnote').length) {
        $(this).siblings('div').appendTo(wrapper);
      }

      // clone the table and append it to wrapper with class clone
      $(this).clone(true).appendTo(wrapper).addClass('clone');

      $(document).trigger('tablesDone');
    });
  }

  $(document).on('tablesDone', function(){
    //console.log('tables done');
  });


})(jQuery);
